import { Injectable, inject } from "@angular/core";
import { Resolve, ActivatedRouteSnapshot } from "@angular/router";
import { Observable } from "rxjs";
import { DashboardFactory } from "../factory/dashboard.factory";
import { Dashboard } from "../models/dashboard";
import { DashboardStore } from "../stores/dashboard.store";

/**
 * Ein Resolver, der vor dem Aktivieren einer Route eine Liste von Dashboards für den angemeldeten Tenant lädt.
 *
 * Wird typischerweise verwendet, um sicherzustellen, dass bereits die Dashboards des Tenants verfügbar sind,
 * bevor die zugehörige Komponente gerendert wird.
 */
@Injectable({ providedIn: 'root' })
export class DashboardByTenantResolver implements Resolve<Dashboard[]> {
  // DashboardStore als Dependency injizieren
  private store = inject(DashboardStore);

  /**
   * Methode, die vom Router aufgerufen wird, bevor die Route aktiviert wird.
   * Hier wird einfach ein Observable einer Dashboard-Liste zurückgegeben.
   *
   * @param route - Der Snapshot der aktuellen Route (hier nicht verwendet, könnte aber z.B. Tenant-ID enthalten)
   * @returns Ein Observable, das die Dashboards des aktuellen Tenants liefert
   */
  resolve(): Observable<Dashboard[]> {
    // Ruft im Store die Methode loadDashboardsForTenant() auf, die die Dashboards vom Server oder Cache lädt
    return this.store.loadDashboardsForTenant();
  }
}
